import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { themeV2 } from '../styles/themeV2';

const FooterContainer = styled.footer`
  border-top: 1px solid ${themeV2.colors.slate[200]};
  padding: ${themeV2.spacing['4xl']} 0;
  background: ${themeV2.colors.slate[50]};
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 ${themeV2.spacing.lg};
  
  @media (min-width: ${themeV2.breakpoints.sm}) {
    padding: 0 ${themeV2.spacing['2xl']};
  }
  
  @media (min-width: ${themeV2.breakpoints.lg}) {
    padding: 0 ${themeV2.spacing['3xl']};
  }
`;

const FooterGrid = styled.div`
  display: grid;
  gap: ${themeV2.spacing['3xl']};
  font-size: ${themeV2.typography.fontSize.sm};
  
  @media (min-width: ${themeV2.breakpoints.md}) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const FooterBrand = styled.div`
  img {
    width: 7rem;
    height: auto;
    margin-bottom: ${themeV2.spacing.lg};
  }
  
  p {
    color: ${themeV2.colors.slate[600]};
    margin: 0;
    line-height: ${themeV2.typography.lineHeight.normal};
  }
`;

const FooterSection = styled.div`
  p {
    font-weight: ${themeV2.typography.fontWeight.semibold};
    color: ${themeV2.colors.slate[900]};
    margin: 0 0 ${themeV2.spacing.lg} 0;
  }
  
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: ${themeV2.spacing.sm};
  }
  
  li a {
    color: ${themeV2.colors.slate[600]};
    text-decoration: none;
    transition: color 0.2s ease;
    
    &:hover {
      color: ${themeV2.colors.slate[900]};
    }
  }
  
  &.legal {
    text-align: center;
    
    p {
      display: none;
    }
    
    ul {
      flex-direction: row;
      justify-content: center;
      gap: ${themeV2.spacing.lg};
    }
  }
`;

const FooterBottom = styled.div`
  margin-top: ${themeV2.spacing['3xl']};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${themeV2.spacing.md};
  font-size: ${themeV2.typography.fontSize.xs};
  color: ${themeV2.colors.slate[500]};
`;

const FooterLinks = styled.div`
  display: flex;
  align-items: center;
  gap: ${themeV2.spacing.lg};
  
  a {
    display: flex;
    align-items: center;
    gap: ${themeV2.spacing.xs};
    color: ${themeV2.colors.slate[500]};
    text-decoration: none;
    transition: color 0.2s ease;
    
    &:hover {
      color: ${themeV2.colors.slate[700]};
    }
    
    svg {
      width: 1rem;
      height: 1rem;
    }
  }
`;

const FooterV2 = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <Container>
        <FooterGrid>
          <FooterBrand>
            <img src="/assets/images/amalgamatech-logo.png" alt="AmalgamaTech" />
            <p>Creamos software que la gente disfruta usar.</p>
          </FooterBrand>
          
          <FooterSection>
            <p>Compañía</p>
            <ul>
              <li><Link to="/nosotros" onClick={() => window.scrollTo(0, 0)}>Quiénes somos</Link></li>
              <li><Link to="/servicios" onClick={() => window.scrollTo(0, 0)}>Servicios</Link></li>
              <li><Link to="/contacto" onClick={() => window.scrollTo(0, 0)}>Contacto</Link></li>
            </ul>
          </FooterSection>
          
          <FooterSection>
            <p>Servicios</p>
            <ul>
              <li><Link to="/servicios" onClick={() => window.scrollTo(0, 0)}>Desarrollo de Software</Link></li>
              <li><Link to="/servicios" onClick={() => window.scrollTo(0, 0)}>Inteligencia Artificial</Link></li>
              <li><Link to="/servicios" onClick={() => window.scrollTo(0, 0)}>Consultoría</Link></li>
              <li><Link to="/servicios" onClick={() => window.scrollTo(0, 0)}>Be Agile</Link></li>
            </ul>
          </FooterSection>
          
          <FooterSection>
            <p>Especializados</p>
            <ul>
              <li>Administración pública</li>
              <li>Soluciones innovadoras</li>
              <li>Tecnología de vanguardia</li>
            </ul>
          </FooterSection>
        </FooterGrid>
        
        <FooterBottom>
          <p>©️ {currentYear} AmalgamaTech. Todos los derechos reservados.</p>
          
          <FooterSection className="legal">
            <p>Legal</p>
            <ul>
              <li><Link to="/cookies" onClick={() => window.scrollTo(0, 0)}>Privacidad</Link></li>
              <li><Link to="/terminos" onClick={() => window.scrollTo(0, 0)}>Términos</Link></li>
              <li><Link to="/cookies" onClick={() => window.scrollTo(0, 0)}>Cookies</Link></li>
            </ul>
          </FooterSection>
        </FooterBottom>
      </Container>
    </FooterContainer>
  );
};

export default FooterV2;